import * as actionTypes from "./actionTypes";
import axios from "../../axios_call";
import swal from "sweetalert";
import {
  BASE_URL,
  getLocalStorageValue,
  getUserId,
} from "../../components/Helpers/helpers";

const queryListStart = () => {
  return {
    type: actionTypes.QUERY_LIST_START,
  };
};

const queryListFail = (error) => {
  return {
    type: actionTypes.QUERY_LIST_FAIL,
    error: error,
  };
};

const queryListSuccess = (message, data, page, timestamp) => {
  return {
    type: actionTypes.QUERY_LIST_SUCCESS,
    message,
    data: data.data,
    totalRecords: data.totalRecords,
    currentPage: data.currentPage,
    totalPages: data.totalPages,
    limit: data.limit,
    count: data.count,
    page,
    timestamp,
  };
};
const queryDeleteAction = (id) => {
  return {
    type: actionTypes.QUERY_DELETE,
    id: id,
  };
};

const queryAddEditStart = () => {
  return {
    type: actionTypes.QUERY_ADD_EDIT_START,
  };
};

const queryAddEditFail = (error) => {
  return {
    type: actionTypes.QUERY_ADD_EDIT_FAIL,
    error: error,
    redirectTo: null,
  };
};

const queryAddEditSuccess = (message, data) => {
  return {
    type: actionTypes.QUERY_ADD_EDIT_SUCCESS,
    message: message,
    data: data,
    redirectTo: "/query",
  };
};

const queryDetailStart = () => {
  return {
    type: actionTypes.QUERY_DETAIL_START,
  };
};

const queryDetailSuccess = (data) => {
  return {
    type: actionTypes.QUERY_DETAIL_SUCCESS,
    data: data,
  };
};

const queryDetailFail = (error) => {
  return {
    type: actionTypes.QUERY_DETAIL_FAIL,
    error: error,
  };
};

const queryStatus = (data, error) => {
  return {
    type: actionTypes.QUERY_STATUS,
    data: data,
    error: error,
  };
};

const queryfilterList = (text) => {
  return {
    type: actionTypes.QUERY_LIST_FILTER,
    text: text,
  };
};

export const queryList = (params = {}) => {
  return (dispatch) => {
    dispatch(queryListStart());
    const OrganisationID = getLocalStorageValue("OrganisationID");
    const currentUser = getUserId();
    const storedPage = Number(localStorage.getItem("openQueriesPage")) || 1;

    const queryParams = {
      OrganisationID,
      page: storedPage ?? 1,
      limit: params.limit || 50,
      UserId: currentUser?.UserID,
      role_name: currentUser?.Role?.Name || "User",
    };

    /* ================= EXTRA TOP-LEVEL PARAMS ================= */
    if (params.Reference) queryParams.Reference = params.Reference;
    if (params.SupplierName) queryParams.SupplierName = params.SupplierName;
    if (params.Description) queryParams.Description = params.Description;
    if (params.Collaborator) queryParams.Collaborator = params.Collaborator;
    if (params.Spend !== undefined && params.Spend !== "")
      queryParams.Spend = params.Spend;
    if (params.Receive !== undefined && params.Receive !== "")
      queryParams.Receive = params.Receive;
    if (params.minDate) queryParams.MinDate = params.minDate;

    if (params.MaxDate) queryParams.MaxDate = params.MaxDate;
    if (params.AccountID) queryParams.AccountID = params.AccountID;
    if (params.search) queryParams.search = params.search;
    if (params.latestRecords) queryParams.latestRecords = params.latestRecords;
    if (params.CurrencyCode) queryParams.CurrencyCode = params.CurrencyCode;
    let finalSort = [];

    if (Array.isArray(params.sort) && params.sort.length > 0) {
      finalSort = params.sort;
    } else {
      const savedSort = localStorage.getItem("QuerySort");
      if (savedSort) {
        try {
          const parsedSort = JSON.parse(savedSort);
          if (Array.isArray(parsedSort)) {
            finalSort = parsedSort;
          }
        } catch (e) {
          console.error("Sort parse error", e);
        }
      }
    }

    if (finalSort.length > 0) {
      queryParams.sort = JSON.stringify(finalSort);
    }

    let finalFilters = [];

    if (Array.isArray(params.filters) && params.filters.length > 0) {
      finalFilters = params.filters;
    } else if (params.filters && Array.isArray(params.filters)) {
      finalFilters = [];
    } else {
      const savedFilter = localStorage.getItem("queryFilter");
      if (savedFilter) {
        try {
          const parsedFilter = JSON.parse(savedFilter);
          if (Array.isArray(parsedFilter)) {
            finalFilters = parsedFilter;
          }
        } catch (e) {
          console.error("Filter parse error", e);
        }
      }
    }

    const cleanedFilters = finalFilters.filter(
      (f) =>
        f?.name &&
        ((f.value !== undefined && f.value !== "") ||
          f.key === "empty" ||
          f.key === "notEmpty"),
    );

    if (cleanedFilters.length > 0) {
      queryParams.filters = JSON.stringify(cleanedFilters);
    }

    Object.keys(queryParams).forEach((key) => {
      if (
        queryParams[key] === "" ||
        queryParams[key] === null ||
        queryParams[key] === undefined
      ) {
        delete queryParams[key];
      }
    });

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BASE_URL}/transaction/combinedRecords?${queryString}`;

    const controller = new AbortController();

    axios
      .get(url, { signal: controller.signal })
      .then((response) => {
        if (response.status === 200) {
          const safeData = Array.isArray(response.data?.data)
            ? response.data
            : { ...response.data, data: [] };

          dispatch(
            queryListSuccess(response.data.message, safeData, queryParams.page),
          );

          return safeData;
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        const message =
          error.response?.data?.message || error.message || "Network error";
        dispatch(queryListFail(message));
      });

    return controller;
  };
};

export const getAllQueryList = (params) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/invoice`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Invalid bill detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const updateQueryLineItem = (InvoiceID, LineItemID, payload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_QUERY_LINE_ITEM_START,
    });

    return axios
      .post(`${BASE_URL}/invoice/${InvoiceID}/line-item/${LineItemID}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: actionTypes.UPDATE_QUERY_LINE_ITEM_SUCCESS,
            data: response.data,
          });
          return response;
        } else {
          dispatch({
            type: actionTypes.UPDATE_QUERY_LINE_ITEM_FAIL,
            error: "Failed to update line item",
          });
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_QUERY_LINE_ITEM_FAIL,
          error: error.message,
        });
        return { data: null };
      });
  };
};

export const updateQueryDetails = (InvoiceID, payload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_QUERY_DETAILS_START,
    });

    return axios
      .post(`${BASE_URL}/invoice/update-bill-details/${InvoiceID}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: actionTypes.UPDATE_QUERY_DETAILS_SUCCESS,
            data: response.data,
          });
          return response;
        } else {
          dispatch({
            type: actionTypes.UPDATE_QUERY_DETAILS_FAIL,
            error: "Failed to update bill details",
          });
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_QUERY_DETAILS_FAIL,
          error: error.message,
        });
        return { data: null };
      });
  };
};

export const getQueryupdate = (InvoiceID, UserID, CurrentLoginedUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/update-invoice-user`, {
        InvoiceID: InvoiceID,
        UserID: UserID,
        CurrentLoginedUserId: CurrentLoginedUserId,
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(queryDetailSuccess(response.data));
          dispatch(getAllQueryList());
          swal("Successfully assigned!", {
            icon: "success",
          });
          return response;
        } else {
          dispatch(queryDetailFail("Invalid bill detail"));
          swal("Error", "Something went to wrong!", "error");
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const queryDelete = (id, token) => {
  return (dispatch) => {
    axios
      .delete("SuperAdmin/deletetransaction?transactionid=" + id)
      .then((response) => {
        if (response.data.status) {
          dispatch(queryDeleteAction(id));
        }
      });
  };
};

export const getQueryDetail = (id) => {
  return (dispatch) => {
    dispatch(queryDetailStart());

    return axios
      .get(`${BASE_URL}/invoice/invoice-detail/${id}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Invalid transaction detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const setQueryStatus = (id, user) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/read-invoice-status/${id}`, {
        user,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryStatus(response.data, ""));
          return response;
        } else {
          dispatch(queryStatus(null, "Invalid transaction detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryStatus(null, error.message));
        return { data: null };
      });
  };
};

export const getApprovedQueryStatus = (InvoiceID, currentUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/update-invoice-status`, {
        InvoiceID,
        currentUserId,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const getDeletedQuery = (InvoiceID) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/delete-invoice-document`, {
        InvoiceID,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Failed to delete bill document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const getVerifiedQueryStatus = (InvoiceID, currentUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/verified-invoice`, {
        InvoiceID,
        currentUserId,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const getUnverifiedQuery = (InvoiceID) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/delete-invoice-document`, {
        InvoiceID,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          return response;
        } else {
          dispatch(queryDetailFail("Failed to delete transaction document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const postQueryAttachmentsFilename = (
  InvoiceID,
  OrganisationID,
  FileName,
) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/${InvoiceID}/Attachments/${FileName}`, {
        InvoiceID,
        OrganisationID,
        FileName,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(queryDetailSuccess(response.data));
          dispatch(getAllQueryList());
          swal("Post Attachment Successfully.", {
            icon: "success",
          });
          return response;
        } else {
          dispatch(queryDetailFail("Failed to delete bill document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(queryDetailFail(error.message));
        return { data: null };
      });
  };
};

export const QueryDetail = (id) => {
  return (dispatch) => {
    axios.get("SuperAdmin/gettransactionbyid?id=" + id).then((response) => {
      if (response.data.result) {
        dispatch(queryDetailSuccess(response.data.result));
      } else {
        dispatch(queryDetailFail("Invalid bill Detail"));
      }
    });
  };
};

export const queryAddEdit = (param) => {
  return (dispatch) => {
    dispatch(queryAddEditStart());
    axios
      .post("SuperAdmin/addupdatetransaction", param)
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result;
          const msg = response.data.message;
          dispatch(queryAddEditSuccess(msg, data));
        } else {
          dispatch(queryAddEditFail(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(queryAddEditFail(error.message));
      });
  };
};

export const addEditQueryErrorNull = () => {
  return (dispatch) => {
    dispatch(queryAddEditFail(null));
  };
};

export const queryListFilter = (filterText) => {
  return (dispatch) => {
    dispatch(queryfilterList(filterText));
  };
};
